import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import SupplierDetailsForm from "../../../components/forms/setup/suppliers/SupplierDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";
import ImportMediaCsvDropzone from "../../../components/importMedia/ImportMediaCsvDropzone";

export function SuppliersViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [suppliers, setSuppliers] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getSuppliers = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `suppliers?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setSuppliers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createSupplier = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("suppliers/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Supplier added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSuppliers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateSupplier = async function (values, index) {
    let callResult = await makePostApiCall(
      `suppliers/${values.id}`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Supplier updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      // const currentItems = [...suppliers.data];
      // var payload = {
      //   index: index,
      //   item: callResult.data.item,
      // };
      // const newItems = updateObjectInArray(currentItems, payload);
      // setSuppliers({ ...suppliers, data: newItems });

      setTimeout(function () {
        getSuppliers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddSupplierSlideOver = (isEdit, supplier, index) => {
    setSlideOver({
      childComponent: (
        <SupplierDetailsForm
          supplier={supplier}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateSupplier(payload, index) : createSupplier(payload)
          }
          title={isEdit ? `Update ${supplier.name}` : "Add new supplier"}
        />
      ),
      open: true,
    });
  };

  const deleteSupplier = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteSupplier/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = suppliers.data.filter((item) => item.id !== id);
      setSuppliers({ ...suppliers, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteSupplier = function (supplier, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteSupplier(supplier.id, index)}
          message={`Are you sure you want to delete  ${supplier.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  const uploadSuppliersCsv = async function (uploadedFile) {
    const { name, value } = uploadedFile.target;
    const payload = { [name]: value };
    let callResult = await makePostApiCall(
      "uploadSuppliersCsv",
      payload,
      "multipart/form-data"
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getSuppliers("", 0);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openImportSuppliers = () => {
    setEmptyModelOpen({
      childComponent: (
        <ImportMediaCsvDropzone
          fileName="suppliersCsv"
          actionCall={uploadSuppliersCsv}
          setOpen={setEmptyModelOpen}
          title="Supplier"
        />
      ),
      open: true,
    });
  };

  return {
    openAddSupplierSlideOver,
    getSuppliers,
    loading,
    suppliers,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteSupplier,
    openImportSuppliers,
  };
}
